<ng-container *ngIf="opened">
	<div
		moveToRoot
		class="backdrop pt-safe-t pr-safe-r pb-safe-b pl-safe-l top-0 left-0 w-full h-full fixed box-border backdrop-menu"
		(click)="outsideClick()"
	>
		<div class="w-full h-full flex items-center justify-center whitespace-pre-line">
			<div
				class="container-popup px-2 pt-1.5 pb-2 rounded-1.5 bg-260 shadow-z-menu flex flex-col items-center justify-start scrollbar-fade overflow-auto"
				[style.maxHeight]="warningModal ? (modalHeight ?? 'unset') : '500px'"
				[style.height]="warningModal ? (modalHeight ?? 'unset') : '100%'"
				[style.width]="warningModal && modalWidth ? modalWidth : null"
				(click)="$event.stopPropagation()"
			>
				<div class="mb-1.5 w-full flex" [class.justify-end]="warningModal">
					<ng-content select="[title]"></ng-content>

					<button
						*ngIf="showClose"
						class="p-0.5 fc-400 hover:fc-800"
						uiNewButtonIcon
						size="SMALL"
						(click)="close()"
					>
						<i class="icon-cross"></i>
					</button>
				</div>
				<div class="flex-auto w-full h-full flex flex-col scrollbar-fade overflow-auto">
					<ng-content></ng-content>
				</div>

				<ng-content select="[footer]"></ng-content>
			</div>
		</div>
	</div>
</ng-container>
